const BeneficioFiscal = () => import('./pages/BeneficioFiscal.vue');
const BeneficioFiscalForm = () => import('./pages/BeneficioFiscalForm.vue');

export default [
  {
    path: '/fiscal/beneficio-fiscal',
    name: 'BeneficioFiscal',
    component: BeneficioFiscal,
    meta: {
      title: 'Código Benefício Fiscal',
    },
  },
  {
    path: '/fiscal/beneficio-fiscal/new',
    name: 'BeneficioFiscalRegister',
    component: BeneficioFiscalForm,
    meta: {
      title: 'Novo Código de Benefício Fiscal',
    },
  },
  {
    path: '/fiscal/beneficio-fiscal/edit/:id',
    name: 'BeneficioFiscalEdit',
    component: BeneficioFiscalForm,
    meta: {
      title: 'Editar Código Benefício Fiscal',
    },
  },
];
